import { render, staticRenderFns } from "./OverlayMenu.vue?vue&type=template&id=09ac0f5e&lang=pug&"
import script from "./OverlayMenu.vue?vue&type=script&lang=js&"
export * from "./OverlayMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports